<div class="card border-0 shadow-sm mb-4">
    <div class="card-body">
        <div class="d-md-flex justify-content-between align-items-center">
            <h4 class="mb-3 mb-md-0 text-secondary">My Score</h4>
            <div class="d-flex flex-wrap align-items-end gap-2">
                <dx-tag-box
                    [dataSource]="siteDataSource"
                    valueExpr="id"
                    displayExpr="name"
                    [(value)]="selectedSites"
                    [showSelectionControls]="true"
                    [searchEnabled]="true"
                    [showClearButton]="true"
                    [maxDisplayedTags]="1"
                    [multiline]="false"
                    placeholder="All Sites"
                    stylingMode="filled"
                    [width]="240"
                    (onValueChanged)="onFiltersChanged()"
                ></dx-tag-box>
                <dx-tag-box
                    [dataSource]="vendorDataSource"
                    valueExpr="id"
                    displayExpr="name"
                    [(value)]="selectedVendors"
                    [showSelectionControls]="true"
                    [searchEnabled]="true"
                    [showClearButton]="true"
                    [maxDisplayedTags]="1"
                    [multiline]="false"
                    placeholder="All Vendors"
                    stylingMode="filled"
                    [width]="240"
                    (onValueChanged)="onFiltersChanged()"
                ></dx-tag-box>
                <dx-date-range-box
                    [multiView]="false"
                    [showClearButton]="false"
                    [(value)]="dateRange"
                    (onValueChanged)="onFiltersChanged()"
                    stylingMode="filled"
                ></dx-date-range-box>
                <dx-button stylingMode="text" icon="export" (onClick)="onExport()"></dx-button>
            </div>
        </div>
    </div>
</div>
